export default {
  card_list: '推荐列表',
  'card-list': '推荐列表',
  'author-manage': '作者管理',
  author_manage: '作者管理',
  'front-user': '普通用户管理',
  lookFrontUser: '普通用户管理',
  incomeDetail: '收入明细',
  'order-manage': '订单管理',
  order_manage: '订单管理',
  header: '用户头像',
  article_manage: '文章管理',
  user_manage: '用户管理',
  person: '个人中心',
  picture_manage: '头像管理',
  index_banner: 'banner管理',
  money_manage: '资金管理'
}
